<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		<!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
	
		<div class="mr-auto">
			<el-form inline ref="form" :model="searchform">
         
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
						    </el-date-picker>
					</el-form-item>
           
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
	
			
    		
		</div>
	<div class="ml-auto">베팅-당첨-롤링*루징%=정산금</div>
	</div>

           <div 
             v-show="loading"
             class="loading-div" 
             v-loading="loading" 
             :style="{ height: windowHeight+ 'px' }">        
            </div>

             <el-table
      :data="tableData"
       row-key="mem_id"
      :tree-props="{children: 'users'}"
      
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">

        <el-table-column
          label="ID"
          type="index"
          align="center"
          width="50">
        </el-table-column>

    <el-table-column
        
        :label="$t('msg.아이디')" prop="mem_id" align="center">
         <template slot-scope="scope"><span @click="openIdModel(scope.row.mem_id)" style="cursor:pointer">{{ scope.row.mem_id}}</span></template>
      </el-table-column>
       <el-table-column
                  prop="mem_id" align="center"
                  :label="$t('msg.루징내역')">
                   <template slot-scope="scope">
        
                          <el-button type="default" size="mini" @click="openAgentModel(scope.row.mem_id)">{{$t('msg.상세보기')}}</el-button>
 
                  </template>
        </el-table-column> 
    

       <el-table-column label=""  align="center" width="45">

            <template slot-scope="scope">

              <span v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#3e3e3e !important">MST</span>
              <span v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
            <span v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
            <span v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
             <span v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>
      

      <!--<el-table-column
        
        :label="$t('msg.충전')" prop="in" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.in)}}</template>
      </el-table-column>
      
      <el-table-column
        
        :label="$t('msg.환전')" prop="out" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.out)}}</template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.충환')" prop="out" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.inout)}}</template>
      </el-table-column>-->

      
    <el-table-column
        :label="$t('newAdd.슬베팅당첨차액')" prop="pc_e" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.sbet)}} <br> {{ formatMoney(scope.row.swin)}} <br> {{ formatMoney(scope.row.sbetwin)}} <br> {{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>
    

      <el-table-column
        :label="$t('newAdd.카베팅당첨차액')" prop="" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.ebet)}} <br> {{ formatMoney(scope.row.ewin)}} <br> {{ formatMoney(scope.row.ebetwin)}} <br> {{ formatMoney(scope.row.tt77)}}</span></template>
      </el-table-column>

  

      <el-table-column
        :label="$t('newAdd.파베팅당첨차액')" prop="pc_e" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.pbet)}} <br> {{ formatMoney(scope.row.pwin)}} <br> {{ formatMoney(scope.row.pbetwin)}} <br> {{ formatMoney(scope.row.tt777)}}</span></template>
      </el-table-column>

     

      <el-table-column
        :label="$t('newAdd.슬루징')" prop="pc_slot" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.pc_slot)}}%</span></template>
      </el-table-column>

        <el-table-column
        :label="$t('newAdd.카루징')" prop="pc_e" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.pc_e)}}%</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('newAdd.파루징')" prop="pc_p" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.pc_p)}}%</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('newAdd.슬정산')" prop="szc" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.szc)}}</span></template>
      </el-table-column>

       <el-table-column
        :label="$t('newAdd.카정산')" prop="ezc" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.ezc)}}</span></template>
      </el-table-column>
      
       <el-table-column
        :label="$t('newAdd.파정산')" prop="pzc" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.pzc)}}</span></template>
      </el-table-column>

         <el-table-column
        :label="$t('newAdd.정산합계')" prop="pzc" align="center">
         <template slot-scope="scope"> <span >{{ formatMoney(scope.row.szc+scope.row.ezc+scope.row.pzc)}}</span></template>
      </el-table-column>

    

    


        
    
         
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
                  <div style="flex: 1;" class="px-2">
                      <el-pagination
                      :current-page="currentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="size"
                      layout="prev, pager, next"
                      :total="total"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange">
                    </el-pagination>
                  </div>
                </el-footer>    
    
      
        

 

				
</div>
 </template>

 <script>
 import layerNew from '../../components/common/layer-new.vue';
 import shopDialog from '../../components/common/shop-dialog.vue';
    export default {
       components: {
     
      layerNew,shopDialog
     
    },

    	data(){
    		return{
           windowHeight: document.documentElement.clientHeight, // 实时屏幕高度
                activeName: 'tab1',
                tapidx:"0",
    			domain:window.sessionStorage.getItem('domain'),
          rosing:window.sessionStorage.getItem('rosing'),
          power:window.sessionStorage.getItem('power'),
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    			
    			searchform:{
    				  searchOptions:[
             
            {
              label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            },
           
            
            ],
           
            value:'',
    				time:[],
            keyword:'',
            pc:'',
    			


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        

    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
                 tabname:'',
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			       
			         
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
        openAgentModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                // layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },
          openIdModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layerNew,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
              area: ['990px', '700px'],
        });
        
        },
    	
    			 // 搜索事件
			searchEvent(){

    			this.getList();
    			this.currentPage=1;
             

    		},
             handleClick(tab, event) {
              //console.log(tab, event);
              this.tapidx=tab.index
               this.tabname=tab.name
              this.getList()
      },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
    		getList(){

    		 
               console.log(this.searchform.time) 
         

               let s_time="";
               let e_time="";
               let ttname=this.tabname;

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls = this.domain+'/admin/rosing_new?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword+'&pc='+this.searchform.pc+'&type=s_code';
    			
    
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                    this.loading =false
                     if(response.data.code !=200)
                            {
                               this.$message({
                                  message:response.data.msg,
                                  type: 'warning'
                                });
                                
                            }else{
                                let data = response.data.data
                                this.tableData =data
                            }
                    
               
            }).catch((error) =>{
            	

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 >>>.el-table__row .cell{
  color:#007bff!important
 }
>>>.el-table__row--level-0 .cell{
  color:#007bff!important
}
>>>.el-table__row--level-1 .cell{
  color: #333 !important;
}
>>>.el-table tr.el-table__row--level-1{
  background-color: #fbfbfb !important;
}
.loading-div{
  width: 100%;
  position: absolute;
 
}

>>>.el-table td.el-table__cell, >>>.el-table th.el-table__cell.is-leaf{
 border-bottom:1px solid #cbcbcb;
}
>>>.el-table--border .el-table__cell{
  border-right:1px solid #cbcbcb;
}

</style>


// WEBPACK FOOTER //
// src/views/jangnew/list.vue